import produce from 'immer';
import { MESSAGES } from '../actionTypes';

const initialState = {
    arrMessages: [],
    arrBroker: [],
    arrOrders: [],
    arrNse: [],
    countExchange: null,
    countBroker: null,
    countOrder: null,
    // Hari k:02-11-2023, BT-109371 message hub - maintained states for API fails
    isReachedLimit: false,
    isBrokerAPIFailed: false,
    isOrderAPIFailed: false,
    isNseAPIFailed: false,
    isLoading: false,
    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
    msgActiveChip: 'broker',
    strNotificationExchange: '',
    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End/
    IsOrderAPIPendingStatus: false,
    IsBrokerAPIPendingStatus: false,
    IsNseAPIPendingStatus: false,
};


const messagesReducer = (state = initialState, actions) => {
    switch (actions.type) {
        // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
        case MESSAGES?.UPDATE_STR_NOTIFCATION_EXCHANGE: {
            return {
                ...state,
                strNotificationExchange: actions?.payload
            };
        }
        case MESSAGES?.UPDATE_MSG_ACTIVE_CHIP: {
            return {
                ...state,
                msgActiveChip: actions?.payload
            };
        }
        // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End/

        case MESSAGES.GET_BROKER_MESSAGE_STATUS: {
            return {
                ...state,
                IsBrokerAPIPendingStatus: actions?.payload
            };
        }
        case MESSAGES.GET_NSE_PENDING_STATUS: {
            return {
                ...state,
                IsNseAPIPendingStatus: actions?.payload
            };
        }
        case MESSAGES.GET_ORDER_MESSAGE_STATUS: {
            return {
                ...state,
                IsOrderAPIPendingStatus: actions?.payload
            };
        }
        case MESSAGES.GET_MESSAGES: {
            return {
                ...state,
                arrMessages: actions.payload
            };
        }
        case MESSAGES.UPDATE_NOTIFICATION_COUNT_STATUS: {
            return {
                ...state,
                isReachedLimit: actions.payload
            };
        }
        case MESSAGES.GET_MESSAGES_BROKER: {     // Hari k:02-11-2023, BT-109371 message hub - to adding the API responses to existing state
            return produce(state, draftState => {
                draftState.isBrokerAPIFailed = false;
                draftState.arrBroker = [...draftState.arrBroker, ...actions?.payload]; // Vinit R : 01-03-2024, BT-109371 Message hub - Previous notifications discarded on infinite scroll
            });
        }
        case MESSAGES.GET_MESSAGE_BROKER_FAILURE: {  // Hari k:02-11-2023, BT-109371 message hub - to update state on API fail
            return { ...state, isBrokerAPIFailed: true };
        }

        case MESSAGES.GET_MESSAGES_ORDERS: {  // Hari k:02-11-2023, BT-109371 message hub - to adding the API responses to existing state
            return produce(state, draftState => {
                draftState.isOrderAPIFailed = false;
                if (actions.payload.orderPageNo === 1) {
                    draftState.arrOrders = [...actions?.payload?.orders];
                } else {
                    draftState.arrOrders = [...draftState.arrOrders, ...actions?.payload?.orders]; // Vinit R : 01-03-2024, BT-109371 Message hub - Previous notifications discarded on infinite scroll
                }
            });
        }
        case MESSAGES.GET_MESSAGE_ORDER_FAILURE: { // Hari k:02-11-2023, BT-109371 message hub - to update state on API fail
            return { ...state, isOrderAPIFailed: true };
        }

        case MESSAGES.GET_MESSAGES_NSE: {   // Hari k:02-11-2023, BT-109371 message hub - to adding the API responses to existing state
            return produce(state, draftState => {
                draftState.isNseAPIFailed = false;
                draftState.arrNse = [...draftState.arrNse, ...actions.payload] // Vinit R : 01-03-2024, BT-109371 Message hub - Previous notifications discarded on infinite scroll
            });
        }
        case MESSAGES.GET_MESSAGE_NSE_FAILURE: { // Hari k:02-11-2023, BT-109371 message hub - to update state on API fail
            return { ...state, isNseAPIFailed: true };
        }
        case MESSAGES.CLEAR_NSE_STATE: {  // Hari k:02-11-2023, BT-109371 message hub - to clear the state while changing exchange drop down
            return { ...state, arrNse: [], isNseAPIFailed: false };
        }
        case MESSAGES.SET_COUNT_EXCHANGE: {
            return {
                ...state,
                countExchange: actions.payload
            };
        }
        case MESSAGES.SET_COUNT_BROKER: {
            return {
                ...state,
                countBroker: actions.payload
            };
        }
        case MESSAGES.SET_COUNT_ORDER: {
            return {
                ...state,
                countOrder: actions.payload
            };
        }
        default:
            return state;
    }
};

export default messagesReducer;